import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const error = () => catchError((err, obs) => {
    console.log(err);
    return of(err);
});
